import { render, staticRenderFns } from "./travaux.vue?vue&type=template&id=57c4d8f4&scoped=true"
import script from "./travaux.vue?vue&type=script&lang=js"
export * from "./travaux.vue?vue&type=script&lang=js"
import style0 from "./travaux.vue?vue&type=style&index=0&id=57c4d8f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c4d8f4",
  null
  
)

export default component.exports